<h1 mat-dialog-title>{{ 'ExportFileDialog.Title' | translate:{'fileType': fileType} }}</h1>
<div mat-dialog-content>
  <p>{{ 'ExportFileDialog.ContentPart1' | translate }}</p>
  <p>{{ 'ExportFileDialog.ContentPart2' | translate }}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Dismiss</button>
  <button mat-button (click)="onExport()" cdkFocusInitial>Export</button>
</div>

